export default __webpack_public_path__ + "static/media/img_01.977e77c1.jpg";